function waitForElements(selector) {
  return new Promise(resolve => {
    const observer = new MutationObserver(() => {
      const parent = document.querySelector(selector);
      if (parent && parent.children.length > 0) {
        observer.disconnect();
        resolve(parent);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

const productJs = {
  init: () => {
    productJs.variantDropdown()
    productJs.changeCustomTextsElem()
    productJs.acceptedTerms()
  },
  variantDropdown: () => {
    const dropDownTitles = document.querySelectorAll(".product-wrapper variant-selects .form__label")

    dropDownTitles.forEach(el => el.addEventListener("click", function () {
      el.parentElement.classList.toggle("closed")
    }))
  },
  variantCustomTrigger: () => {
    document.addEventListener("change", function (e) {
      if (e.target.matches(".variant-dropwdown-wrapper input[type='radio']")) {
        const fieldset = e.target.closest("fieldset")
        const variantName = fieldset?.querySelector("legend")?.textContent?.trim()
    
        if (!variantName) return

        const radios = Array.from(fieldset.querySelectorAll("input[type='radio']"))
        const selectedIndex = radios.findIndex(r => r.checked)

        if (selectedIndex === -1) return

        const customilyInputs = document.querySelectorAll(`.customily_option .swatch-container input[name='properties[${variantName}]']`)
        const targetInput = customilyInputs[selectedIndex]
    
        if (targetInput) {
          // Força a seleção do input
          targetInput.checked = true

          // Dispara evento de mudança para o Customily captar
          const changeEvent = new Event("change", { bubbles: true })
          targetInput.dispatchEvent(changeEvent)
        }
      }
    })

    // waitForElements(".variant-dropwdown-wrapper").then(() => {
    //   const initialRadios = document.querySelectorAll(".variant-dropwdown-wrapper input[type='radio']:checked")
    //   initialRadios.forEach(radio => {
    //     radio.dispatchEvent(new Event("change", { bubbles: true }))
    //   })
    // })
  },
  changeCustomTextsElem: () => {
    waitForElements(".customily-set").then(() => {
      document.querySelectorAll(".customily-set").forEach(el => {
        const allOptions = Array.from(el.querySelectorAll(".customily_option"))
        // Coleta dinamicamente os nomes das variantes do DOM:
        const variantNames = Array.from(document.querySelectorAll(".variant-dropwdown-wrapper fieldset"))
          .map(f => f.querySelector("legend")?.textContent?.trim())
          .filter(Boolean)

        const variantControlledOptions = allOptions.filter(opt => {
          const input = opt.querySelector(".swatch-container input[type='radio'][name^='properties[']")
          if (!input) return false
          const inputName = input.getAttribute("name") // exemplo: properties[Tamanho]
          return variantNames.some(name => inputName.includes(`properties[${name}]`))
        })
        
        const customOptions = allOptions.filter(opt => !variantControlledOptions.includes(opt))

        el.innerHTML = ""; // Limpa o conteúdo original

        // Agrupa os elementos manipulados pela variante em um grupo separado e esconde
        if (variantControlledOptions.length) {
          const variantGroup = document.createElement("div")
          variantGroup.classList.add("customily_group", "variant-controlled")
          variantGroup.style.display = "none"
          variantControlledOptions.forEach(opt => variantGroup.appendChild(opt))
          el.appendChild(variantGroup)
        }

        const grouped = {}

        customOptions.forEach((opt, index) => {
          const input = opt.querySelector("input[name^='properties[']")
          let baseName

          if (input) {
            const nameAttr = input.getAttribute("name")
            const match = nameAttr.match(/^properties\[(.*?)\]$/)
            if (match) {
              const fullName = match[1]
              // Agrupa campos de fonte junto com seus campos de texto
              baseName = fullName.replace(/\s(Font|Fonte|Cor|Color|Style)$/i, "")
            }
          }

          if (!baseName) baseName = `__no_property_${index}`

          if (!grouped[baseName]) grouped[baseName] = []
          grouped[baseName].push(opt)
        })

        Object.values(grouped).forEach(groupItems => {
          const groupDiv = document.createElement("div")
          groupDiv.classList.add("customily_group")

          groupDiv.addEventListener("click", function(e) {
            if (e.target.className.includes("group-first-elem")) {
              groupDiv.classList.toggle("closed")
            }
          })

          groupItems[0].classList.add("group-first-elem")
          groupItems.forEach(item => groupDiv.appendChild(item))

          el.appendChild(groupDiv)
        })
      })

      productJs.variantCustomTrigger()
    });
  },
  acceptedTerms: ()=> {
    const acceptTermsEl = document.querySelector(".product-form__buttons .accept-terms");

    acceptTermsEl.addEventListener("click", function() {
      acceptTermsEl.parentElement.classList.toggle("terms-accepted")
    })
  }
}

productJs.init()